//
// Row editing in the mapping and template tables
// ----------------------------------------------
//
// Cancel has to put a row back to what it showed when editing began. Both
// tables used to look that up in the server's answer from the moment they were
// loaded — `data.mapping`, which is never written again. A row saved in this
// session therefore came back with the value from before that save.
//
// The fix is to remember the row when editing begins. What the row shows at
// that moment is the last saved state: outside edit mode nothing changes a row
// except a save.
//
// ⚠️ A deep copy, not a spread. The template's format cell writes straight into
// `row.format`, and the rows are shallow copies of the loaded entries — a spread
// would share that object and the snapshot would change along with the edit.
//

/** Starts editing a row and remembers the fields cancel has to restore. */
export function beginRowEdit(row: any, fields: readonly string[]) {
    row.before = structuredClone(Object.fromEntries(fields.map((field) => [field, row[field]])))
    row.status = 'EDIT'
    row.edit = {}
}

/** Leaves edit mode. Called before a row is saved, so no bookkeeping travels with it. */
export function endRowEdit(row: any) {
    row.status = null
    delete row.edit
    delete row.before
}

/**
 * Puts the row back to where editing began.
 *
 * `loaded` is the entry from loading. It is the source only for a row without a
 * snapshot — one put into edit mode by an older version of the screen and kept
 * in the tab since.
 */
export function cancelRowEdit(row: any, loaded: any, fields: readonly string[]) {
    const source = row.before ?? loaded
    if (source) for (const field of fields) row[field] = structuredClone(source[field])
    endRowEdit(row)
}
